var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-check-circle-mono"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.707 10.215L12.124 15.799C11.9359 15.9858 11.6816 16.0906 11.4165 16.0906C11.1514 16.0906 10.8971 15.9858 10.709 15.799L7.293 12.383C7.20016 12.2902 7.12651 12.1799 7.07626 12.0586C7.02601 11.9373 7.00015 11.8073 7.00015 11.676C7.00015 11.4108 7.10549 11.1565 7.293 10.969C7.48051 10.7815 7.73482 10.6762 8 10.6762C8.26518 10.6762 8.51949 10.7815 8.707 10.969L11.416 13.678L16.293 8.801C16.3858 8.70816 16.4961 8.63451 16.6174 8.58426C16.7387 8.53401 16.8687 8.50815 17 8.50815C17.1313 8.50815 17.2613 8.53401 17.3826 8.58426C17.5039 8.63451 17.6142 8.70816 17.707 8.801C17.7998 8.89384 17.8735 9.00407 17.9237 9.12537C17.974 9.24668 17.9998 9.3767 17.9998 9.508C17.9998 9.6393 17.974 9.76932 17.9237 9.89063C17.8735 10.0119 17.7998 10.1222 17.707 10.215ZM12.5 1C6.425 1 1.5 5.925 1.5 12C1.5 18.075 6.425 23 12.5 23C18.575 23 23.5 18.075 23.5 12C23.5 5.925 18.575 1 12.5 1Z",
    fill: "#0071E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckBlue);
export default __webpack_public_path__ + "static/media/icon_check_blue.bad999564404b98dad53a1d690265716.svg";
export { ForwardRef as ReactComponent };